import React, { useState, useEffect } from "react";

const DataService = ({
  url,
  isDashBoardUrl,
  method,
  isEnabled,
  data,
  onSuccess,
  onError,
}) => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isEnabled) {
      const fetchData = async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
          };

          let body;
          if (method === "POST") {
            body = JSON.stringify(data);
          }

          const response = await fetch(url, {
            method,
            headers,
            body,
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const responseData = await response.json();

          setResponse(responseData);
          onSuccess(responseData);
        } catch (error) {
          setError(error);
          onError(error);
        }
      };
      fetchData();
    }
  }, [isEnabled]);

  return null; // This component doesn't render anything
};

export default DataService;
